<template>
  <div>
    <a-card :bordered="false" title="折旧计提">
      <div class="table-operator" style="margin-bottom: 12px;">
        <a-button type="primary" icon="calculator" v-if="btnEnableList.indexOf('1') > -1" @click="openCalc">计提</a-button>
        <a-button style="margin-left: 8px" icon="sync" @click="loadData">刷新</a-button>
        <a-button style="margin-left: 8px" icon="download" v-if="btnEnableList.indexOf('3') > -1" @click="exportExcel">导出</a-button>
      </div>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin-bottom: 12px;">
          <a-form-item label="期间">
            <a-select :value="queryParam.depYear" style="width: 90px" placeholder="年" @change="(v) => setYear(v)">
              <a-select-option v-for="y in yearOptions" :key="y" :value="y">{{ y }}年</a-select-option>
            </a-select>
            <a-select :value="queryParam.depMonth" style="width: 80px; margin-left: 4px" placeholder="月" @change="(v) => setMonth(v)">
              <a-select-option v-for="m in 12" :key="m" :value="m">{{ m }}月</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="状态">
            <a-select placeholder="全部" allow-clear style="width: 100px" v-model="queryParam.status">
              <a-select-option value="0">未审核</a-select-option>
              <a-select-option value="1">已审核</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" icon="search" @click="searchQuery">查询</a-button>
            <a-button style="margin-left: 8px" icon="reload" @click="searchReset">重置</a-button>
          </a-form-item>
        </a-form>
      </div>
      <a-table bordered size="middle" rowKey="id" :columns="columns" :dataSource="tableData"
        :loading="loading" :pagination="false" :scroll="tableScroll">
        <span slot="status" slot-scope="text">
          <a-tag :color="text === '1' ? 'green' : 'orange'">{{ text === '1' ? '已审核' : '未审核' }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="openDetail(record)">明细</a>
          <a-divider type="vertical" />
          <a @click="handlePrint(record)">打印</a>
          <a-divider type="vertical" />
          <template v-if="record.status === '0'">
            <a v-if="canAudit(billPrefix(record.billNo))" @click="handleAudit(record)">审核</a>
            <a-divider v-if="canAudit(billPrefix(record.billNo))" type="vertical" />
            <a v-if="canSubmitFlow(billPrefix(record.billNo))" @click="handleSubmitFlow(record)">提交审批</a>
            <a-divider v-if="canSubmitFlow(billPrefix(record.billNo))" type="vertical" />
            <a-popconfirm title="作废并删除该计提单?" @confirm="() => handleDelete(record)">
              <a style="color: red;">作废</a>
            </a-popconfirm>
          </template>
          <template v-else>
            <a-popconfirm title="反审核将冲销明细与凭证，确认?" @confirm="() => handleUnaudit(record)">
              <a>反审核</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>
      <a-pagination style="margin-top: 12px; text-align: right;" show-size-changer show-quick-jumper
        :current="ipagination.current" :page-size="ipagination.pageSize"
        :page-size-options="ipagination.pageSizeOptions" :total="ipagination.total"
        @change="handleTableChange" @showSizeChange="handleTableChange" />
    </a-card>

    <!-- 计提弹窗：期间选择 + 预览（工作量法可录入）+ 生成 -->
    <a-modal title="折旧计提" :width="960" :visible="calcVisible" :maskClosable="false"
      :footer="null" @cancel="calcVisible = false">
      <a-form layout="inline" style="margin-bottom: 12px;">
        <a-form-item label="计提年">
          <a-select v-model="calcForm.depYear" style="width: 90px">
            <a-select-option v-for="y in yearOptions" :key="y" :value="y">{{ y }}年</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="计提月">
          <a-select v-model="calcForm.depMonth" style="width: 80px">
            <a-select-option v-for="m in 12" :key="m" :value="m">{{ m }}月</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" icon="eye" :loading="previewing" @click="handlePreview">预览</a-button>
          <a-button style="margin-left: 8px" type="primary" icon="check" :loading="generating"
            :disabled="!previewData" @click="handleGenerate">生成计提单</a-button>
        </a-form-item>
      </a-form>
      <template v-if="previewData">
        <a-alert type="info" show-icon style="margin-bottom: 8px"
          :message="`计提资产 ${previewData.assetCount} 台，折旧总额 ${previewData.totalAmount || 0}` + (previewData.skipped && previewData.skipped.length ? `；跳过 ${previewData.skipped.length} 台（提足/无工作量）` : '')" />
        <a-table bordered size="small" rowKey="assetId" :columns="previewColumns"
          :dataSource="previewData.items" :pagination="false"
          :scroll="{ x: 'max-content', y: 320 }">
          <template slot="workload" slot-scope="text, record">
            <a-input-number v-if="record.method === 2" v-model="record.workload" :min="0" :precision="2"
              style="width: 120px" placeholder="录入工作量" @change="() => markWorkload(record)" />
            <span v-else>-</span>
          </template>
        </a-table>
        <div style="margin-top: 8px; color: #999;">工作量法资产在预览表录入本期工作量后重新预览或直接生成；期间已结账将被拦截并提示。</div>
      </template>
    </a-modal>

    <!-- 明细查看 -->
    <a-modal :title="`计提单明细 ${detail.billNo || ''}`" :width="860" :visible="detailVisible"
      :footer="null" @cancel="detailVisible = false">
      <a-descriptions bordered size="small" :column="3" style="margin-bottom: 8px">
        <a-descriptions-item label="期间">{{ detail.depYear }}-{{ detail.depMonth }}</a-descriptions-item>
        <a-descriptions-item label="资产数">{{ detail.assetCount }}</a-descriptions-item>
        <a-descriptions-item label="折旧总额">{{ detail.totalAmount }}</a-descriptions-item>
      </a-descriptions>
      <a-table bordered size="small" rowKey="id" :columns="detailColumns" :dataSource="detail.details"
        :pagination="false" :scroll="{ x: 'max-content', y: 360 }" />
    </a-modal>
    <asset-bill-print ref="assetPrint" />
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ApprovalButtonMixin from './mixins/ApprovalButtonMixin'
import { depBillList, depBillGet, depBillPreview, depBillGenerate, depBillAudit, depBillUnaudit, depBillDelete } from './api/fixedAsset'
import AssetBillPrint from './AssetBillPrint.vue'

export default {
  name: 'DepreciationBillList',
  mixins: [JeecgListMixin, ApprovalButtonMixin],
  components: { AssetBillPrint },
  data() {
    const now = new Date()
    return {
      urlPath: '/plugin/fixed-asset/dep-bill',
      prefixNo: 'ZCJT',
      loading: false,
      previewing: false,
      generating: false,
      calcVisible: false,
      detailVisible: false,
      detail: {},
      previewData: null,
      workloads: {},
      yearOptions: [now.getFullYear() + 1, now.getFullYear(), now.getFullYear() - 1, now.getFullYear() - 2],
      calcForm: { depYear: now.getFullYear(), depMonth: now.getMonth() + 1 },
      tableData: [],
      tableScroll: { x: 'max-content', y: 400 },
      queryParam: { depYear: now.getFullYear(), depMonth: now.getMonth() + 1 },
      ipagination: { current: 1, pageSize: 10, pageSizeOptions: ['10', '20', '50'], total: 0 },
      columns: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 180 },
        { title: '单据号', dataIndex: 'billNo', width: 160 },
        { title: '期间', dataIndex: 'period', width: 100 },
        { title: '资产数', dataIndex: 'assetCount', width: 90 },
        { title: '折旧总额', dataIndex: 'totalAmount', width: 130 },
        { title: '跳过清单', dataIndex: 'skippedList', width: 260, ellipsis: true },
        { title: '状态', dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } }
      ],
      previewColumns: [
        { title: '资产编码', dataIndex: 'assetCode', width: 130 },
        { title: '资产名称', dataIndex: 'assetName', width: 170 },
        { title: '折旧方法', dataIndex: 'methodText', width: 110 },
        { title: '本期工作量', dataIndex: 'workload', width: 150, scopedSlots: { customRender: 'workload' } },
        { title: '本期折旧', dataIndex: 'amount', width: 120 },
        { title: '计提后累计折旧', dataIndex: 'afterAccumDep', width: 140 },
        { title: '计提后净值', dataIndex: 'afterNetValue', width: 120 }
      ],
      detailColumns: [
        { title: '资产编码', dataIndex: 'assetCode', width: 130 },
        { title: '资产名称', dataIndex: 'assetName', width: 170 },
        { title: '本期折旧', dataIndex: 'depreciationAmount', width: 120 },
        { title: '累计折旧', dataIndex: 'accumulatedDepreciation', width: 130 },
        { title: '净值', dataIndex: 'netValue', width: 120 }
      ],
      methodMap: { 1: '年限平均法', 2: '工作量法', 3: '双倍余额递减', 4: '年数总和法' }
    }
  },
  mounted() {
    this.$nextTick(() => { this.tableScroll.y = Math.max(300, window.innerHeight - 360) })
  },
  created() {
    this.loadData()
    this.loadApprovalState()
  },
  methods: {
    setYear(v) { this.queryParam.depYear = v },
    setMonth(v) { this.queryParam.depMonth = v },
    loadData() {
      this.loading = true
      const params = {
        page: this.ipagination.current, pageSize: this.ipagination.pageSize,
        depYear: this.queryParam.depYear || null, depMonth: this.queryParam.depMonth || null,
        status: this.queryParam.status || null
      }
      depBillList(params).then((res) => {
        this.loading = false
        if (res && res.success) {
          const records = (res.data && res.data.records) || []
          records.forEach((r) => { r.period = `${r.depYear}-${String(r.depMonth).padStart(2, '0')}` })
          this.tableData = records
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
      }).catch(() => { this.loading = false })
    },
    searchQuery() { this.ipagination.current = 1; this.loadData() },
    searchReset() {
      const now = new Date()
      this.queryParam = { depYear: now.getFullYear(), depMonth: now.getMonth() + 1 }
      this.ipagination.current = 1
      this.loadData()
    },
    handleTableChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    openCalc() {
      this.previewData = null
      this.workloads = {}
      this.calcVisible = true
    },
    markWorkload(record) {
      if (record.workload != null) this.workloads[record.assetId] = record.workload
    },
    handlePreview() {
      this.previewing = true
      depBillPreview({ depYear: this.calcForm.depYear, depMonth: this.calcForm.depMonth, workloads: this.workloads }).then((res) => {
        this.previewing = false
        if (res && res.success) {
          const data = res.data || {}
          ;(data.items || []).forEach((it) => {
            it.methodText = this.methodMap[it.method] || it.method
            if (it.workload != null && this.workloads[it.assetId] == null) this.workloads[it.assetId] = it.workload
          })
          this.previewData = data
        } else {
          this.$message.error((res && res.message) || '预览失败')
        }
      }).catch(() => { this.previewing = false; this.$message.error('预览失败') })
    },
    handleGenerate() {
      this.generating = true
      depBillGenerate({ depYear: this.calcForm.depYear, depMonth: this.calcForm.depMonth, workloads: this.workloads }).then((res) => {
        this.generating = false
        if (res && res.success) {
          this.$message.success(`生成成功：${(res.data && res.data.billNo) || ''}`)
          this.calcVisible = false
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '生成失败')
        }
      }).catch(() => { this.generating = false; this.$message.error('生成失败') })
    },
    openDetail(r) {
      depBillGet(r.id).then((res) => {
        if (res && res.success) { this.detail = res.data || {}; this.detailVisible = true }
      })
    },
    handleAudit(r) {
      depBillAudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '审核失败') }
      })
    },
    /** 提交审批（workflow bigType=8 折旧计提单） */
    handleSubmitFlow(r) {
      this.$confirm({
        title: '提交审批', content: `确认提交计提单 ${r.billNo} 至审批流程？`,
        onOk: () => this.submitFlowById(8, r.billNo).then((res) => {
          if (res && res.code === 200) this.loadData()
        })
      })
    },
    handleUnaudit(r) {
      depBillUnaudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('反审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '反审核失败') }
      })
    },
    handleDelete(r) {
      depBillDelete(r.id).then((res) => {
        if (res && res.success) { this.$message.success('作废成功'); this.loadData() } else { this.$message.error((res && res.message) || '作废失败') }
      })
    },
    /** 打印计提单（明细作为打印明细表） */
    handlePrint(r) {
      depBillGet(r.id).then((res) => {
        if (res && res.success) {
          const data = res.data || {}
          this.$refs.assetPrint.show(r.billNo, '折旧计提单', data, data.details || [])
        }
      })
    },
    exportExcel() {
      const list = this.tableData.map((r) => [
        r.billNo || '', r.period || '', r.assetCount == null ? '' : r.assetCount,
        r.totalAmount == null ? '' : r.totalAmount, r.skippedList || '',
        r.status === '1' ? '已审核' : '未审核'
      ])
      this.handleExportXlsPost('折旧计提单', '折旧计提单', '单据号,期间,资产数,折旧总额,跳过清单,状态', '', list)
    }
  }
}
</script>
